/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const pluginPostbackAddPaymentOrderRequestSchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string().min(1),
	order_id: z.uuid(),
	payment_id: z.uuid(),
	payment_amount: z.number(),
	paid_at: z.iso.datetime().nullish(),
	payment_type_id: z.uuid(),
});
